import { Component, OnInit, Input, DoCheck, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PATTERNS, getYears, getProvinces, getCities } from '../../../../globals';
import * as moment from 'moment';
import { CleanerService } from "../../../../injections/cleaner.service";

@Component({
    selector: 'cleaner-data',
    templateUrl: '../../templates/partials/data-cleaner.html'
})

export class DataCleanerComponent implements OnInit{

    @Input() editDataCleaner: boolean;
    public updateCleaner: FormGroup;
    public years = [];
    @Input() data;
    @Input() blocked;
    @Output() updateCleanerEmitter = new EventEmitter;
    public offices;
    public cities;
    constructor(private _fb: FormBuilder, private cleanerService: CleanerService) { 
        getYears(this.years);
        this.offices = getProvinces();
        this.cities = getCities();
    }

    public toggleDataCleaner(){
       
        this.parseToForm();
        //this.serviceCopy = Object.assign({}, this.service);
        this.editDataCleaner = (this.editDataCleaner) ? false : true;
    }

    public parseToForm(): void {
        var object = {
            document: this.data["document"],
            month_val: this.data["document_expiration_month"],
            year_val: this.data["document_expiration_year"],
            door: this.data["door"],
            floor: this.data["floor"],
            address: this.data["address"],
            number: this.data["number"],
            name: this.data["name"],
            surname: this.data["surname"],
            phone: this.data["phone_1"] || '',
            postal_code: this.data["zip_code"],
            iban: this.data["iban"],
            email: this.data["email"],
            province: this.data["id_clintu_office"]
        };
        this.updateCleaner.setValue(object);
    }

    public checkValidityDate() {
        if(this.updateCleaner.value.year_val && this.updateCleaner.value.month_val){
            var expiration = this.updateCleaner.value.month_val + "/" + this.updateCleaner.value.year_val;
            var today = moment();
            var e = moment(expiration,"MM/YYYY");
            if(e < today){
                this.updateCleaner.controls['month_val'].setErrors({'incorrect': true});
                this.updateCleaner.controls['year_val'].setErrors({'incorrect': true});
            }else{
                this.updateCleaner.controls['month_val'].setErrors(null);
                this.updateCleaner.controls['year_val'].setErrors(null);
            }
        }
    }

    public parseToSend() {
        
        var object = {
            document: this.updateCleaner["controls"]["document"]["value"],
            document_expiration_month: this.updateCleaner["controls"]["month_val"]["value"], 
            document_expiration_year: this.updateCleaner["controls"]["year_val"]["value"],
            name: this.updateCleaner["controls"]["name"]["value"],
            surname: this.updateCleaner["controls"]["surname"]["value"],
            address: this.updateCleaner["controls"]["address"]["value"],
            number: this.updateCleaner["controls"]["number"]["value"],
            floor: this.updateCleaner["controls"]["floor"]["value"],
            door: this.updateCleaner["controls"]["door"]["value"],
            zip_code: this.updateCleaner["controls"]["postal_code"]["value"],
            iban: this.updateCleaner["controls"]["iban"]["value"],
            email: this.updateCleaner["controls"]["email"]["value"],
            phone_1: this.updateCleaner["controls"]["phone"]["value"],
            id_clintu_office: parseInt(this.updateCleaner["controls"]["province"]["value"])
        }
        if(this.data["iban"] == this.updateCleaner["controls"]["iban"]["value"]) delete object["iban"];
        return object;

    }

    public getYears() {
        var actualYear = moment();
        
        for(var i = 0; i <= 10; i++){
            var string = actualYear.format("YYYY");
            this.years.push(string);
            actualYear.add(1, 'years');

        }
    }

    public updateCleanerForm(){
        if(this.updateCleaner.valid){
            var data = this.parseToSend();
            this.updateCleanerEmitter.emit(data);
            this.editDataCleaner = false;
        }
    }
    
    ngOnInit() {

        this.updateCleaner = this._fb.group({
            document: ['', [Validators.required]],
            month_val: ['', [Validators.required]],
            year_val: ['', [Validators.required]],
            name: ['', [Validators.required]],
            surname: ['', [Validators.required]],
            address: ['', []],
            number: ['', []],
            phone: ['', []],
            floor: ['', []],
            door: ['', []],
            postal_code: ['', [Validators.pattern(PATTERNS["postalCode"])]],
            iban: ['', []],
            email: ['', [Validators.pattern(PATTERNS["email"])]],
            province: ['', [Validators.required]],
        });

        this.updateCleaner.valueChanges.subscribe(data => {
             this.checkValidityDate();
         });
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/cleaners/components/dummy/data-cleaner.component.ts